import React, { useEffect, useRef } from 'react';
import Lottie from 'lottie-react';
import '../css/TitleBar.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Import animations
import userDetails from '../assets/userDetails.json';
import payment from '../assets/payment.json';
import CartImages from '../assets/cart.json';
import Book from '../assets/book.json';
import Report from '../assets/report.json';

// Map EXACT prop values to animation data
const animationMap = {
  CartImages: CartImages,
  userDetails: userDetails,
  payment: payment,
  Book: Book,
  report:Report

};

// Map titles to descriptions and icons
const contentMap = {
  "Your Shopping Cart": {
    description: "Browse and manage your shopping cart with ease. Add, remove, or save items for later.",
    // icon: "🛒"
  },
  "PIP Details": {
    description: "Update and manage your personal information, preferences, and account settings securely.",
    // icon: "👤"
  },
  "Individual Details": {
    description: "Update and manage your personal information, preferences, and account settings securely.",
    // icon: "👤"
  },
  "Transaction Details": {
    description: "Complete your purchase with our secure and convenient payment options.",
    // icon: "💳"
  },
  "Payment History": {
    description: "Complete your purchase with our secure and convenient payment options.",
    // icon: "💳"
  },
"My Courses": {
  description: "Explore our extensive collection of books and find your next great read.",
  // icon: "📚"
},
"Report": {
  description: "View and generate detailed reports of your course progress and performance.",
  // icon: "📊"  // bar chart icon representing reports
}
,
  // Default fallback
  "default": {
    description: "Discover more about our services and features designed just for you.",
    // icon: "⭐"
  }
};

const TitleBar = ({ title, image }) => {
  const lottieRef = useRef();

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
    AOS.refresh();
  }, []);

  // Slow down Lottie animation speed
  useEffect(() => {
    if (lottieRef.current) {
      lottieRef.current.setSpeed(0.6);
    }
  }, [image]);

  const animationData = animationMap[image];
  const content = contentMap[title] || contentMap.default;

  return (
    <div className="title-bar">
      <div className="title-content" data-aos="fade-left">
        <div className="title-header">
          <span className="title-icon">{content.icon}</span>
          <h2 className="section-title1">{title}</h2>
        </div>
        <p className="title-description">{content.description}</p>
      </div>

      {animationData ? (
        <div className="title-image" data-aos="zoom-in">
          <Lottie
            lottieRef={lottieRef}
            animationData={animationData}
            loop={true}
            autoplay={true}
            className="section-title1-img"
          />
        </div>
      ) : (
        <div style={{ color: 'red' }}>
          Could not find animation for: "{image}". Available options: {Object.keys(animationMap).join(', ')}
        </div>
      )}
    </div>
  );
};

export default TitleBar;